import { all, fork } from 'redux-saga/effects';

import watchStoresRequest from './storesRequest';

function* storeSagas() {
  yield all([fork(watchStoresRequest)]);
}

export default storeSagas;
